
module.service('ModelService', function($http, $q, $timeout, ApiUrl, momentConvertFilter) {

    var deleteHandlers = {},
        changeHandlers = {},
        issueHandlers = {},
        createHandlers = {},
        self = this;


    function invokeHandlers(handlerCache, items, loaders) {
        var i, j, item, handlers;
        if (!angular.isArray(items)) return;

        for (i = 0; i < items.length; i++) {
            item = items[i];

            handlers = handlerCache[item.name] || [];
            for (j = 0; j < handlers.length; j++) {
                handlers[j](item.id, item.owner);
            }

            handlers = handlerCache.all || [];
            for (j = 0; j < handlers.length; j++) {
                handlers[j](item.name, item.id);
            }
        }
    }

    function processResponseMetadata(response) {
        invokeHandlers(createHandlers, response.data.$created)
        invokeHandlers(deleteHandlers, response.data.$deleted);
        invokeHandlers(changeHandlers, response.data.$changed);
        invokeHandlers(issueHandlers, response.data.$issues);

        return momentConvertFilter(response.data);
    }

    function unwrapSingle(data) { return data.item; }
    function unwrapList(data) {
        if (angular.isDefined(data.pager)) {
            data.items.pager = data.pager;
        }
        return data.items;
    }

    function copyResultInto(destination) {
        return function(data) {
            angular.copy(data, destination);
            return destination;
        }
    }

    this.copyInto = copyResultInto;


    this.post = function(name, data) {
        return $http.post(ApiUrl(name), data)
            .then(processResponseMetadata)
            .then(unwrapSingle);
    };

    this.postRelation = function(name, id, relation, data) {
        return $http.post(ApiUrl(name, id, relation), data)
            .then(processResponseMetadata)
            .then(unwrapSingle);
    };

    this.postModelRelation = function(model, relation, data) {
        return this.postRelation(model.$model_name, model.id, relation, data);
    };

    this.index = function(name, params) {
        params = params || {};
        return $http.get(ApiUrl(name), {params: params})
            .then(processResponseMetadata)
            .then(unwrapList);
    };

    this.get = function(name, id) {
        return $http.get(ApiUrl(name, id))
            .then(processResponseMetadata)
            .then(unwrapSingle);
    };

    this.getRelation = function(name, id, relation, params) {
        return $http.get(ApiUrl(name, id, relation), {params:params})
            .then(processResponseMetadata)
            .then(function(data) {
                if (data.items) {
                    return unwrapList(data);
                } else {
                    return unwrapSingle(data);
                }
            });
    }

    this.refresh = function(model) {
        this.get(model.$model_name, model.id)
            .then(copyResultInto(model));
    };

    this.refreshRelation = function(model, relation) {
        this.getModelRelation(model, relation)
            .then(copyResultInto(model));
    };

    this.getModelRelation = function(model, relation, params) {
        return this.getRelation(model.$model_name, model.id, relation, params);
    }

    this.patch = function(name, id, data) {
        return $http.patch(ApiUrl(name, id), data)
            .then(processResponseMetadata)
            .then(unwrapSingle);
    };

    this.patchModel = function(model, data) {
        return this.patch(model.$model_name, model.id, data)
            .then(copyResultInto(model));
    }

    this.tagModel = function(model, tag) {
        return this.postModelRelation(model, 'tags', tag);
    };

    this.untagModel = function(model, tag) {
        return $http({
            method: 'DELETE',
            url: ApiUrl(model.$model_name, model.id, 'tags'),
            headers: {'Content-Type': 'application/json'},
            data: tag,
        }).then(processResponseMetadata).then(unwrapSingle);
    };

    this.delete = function(name, id) {
        return $http.delete(ApiUrl(name, id))
            .then(processResponseMetadata);
    };

    this.deleteModel = function(model) {
        return this.delete(model.$model_name, model.id);
    };

    this.deleteModelRelation = function(model, relation, id) {
        return $http.delete(ApiUrl(model.$model_name, model.id,
                                   relation, id))
    };

    function subscribeFunction(handlerCache) {
        return function(modelName, fn) {
            handlerCache[modelName] = handlerCache[modelName] || [];
            addToArray(handlerCache[modelName], fn);
            return function() {
                removeFromArray(handlerCache[modelName], fn);
            }
        }
    }

    this.listenForCreates = subscribeFunction(createHandlers);
    this.listenForDeletes = subscribeFunction(deleteHandlers);
    this.listenForChanges = subscribeFunction(changeHandlers);
    this.listenForIssues = subscribeFunction(issueHandlers);

    this.listenFor = function(type, modelName, fn) {
        switch (type) {
            case 'create':
                return this.listenForCreates(modelName, fn);
            case 'delete':
                return this.listenForDeletes(modelName, fn);
            case 'update':
                return this.listenForChanges(modelName, fn);
            case 'issues':
                return this.listenForIssues(modelName, fn);
            default:
                return angular.noop;
        }
    };

    this.copyFields = function(model, fields) {
        fields = fields || [];
        if (fields.length === 0) {
            return angular.copy(model);
        }
        var copy = {}
        fields.forEach(function(name) {
            copy[name] = angular.copy(model[name]);
        });
        return copy;
    }

    function isSameModel(a, b) {
        return a.$id === b.$id;
    }

    this.removeModel = function(model, array) {
        removeByPredicate(array, isSameModel.bind(this, model));
        return array
    }


    this.removeById = function(model_name, id, array) {
        var fakeModel = {$id: model_name + '.' + id};
        return this.removeModel(fakeModel, array);
    }

    this.appendToArray = function(array) {
        return function(model) {
            for (var i = 0; i < array.length; i++) {
                if (isSameModel(model, array[i])) {
                    return;
                }
            }
            array.push(model);
        };
    };

    this.assertRelation = function(propertyName, value, rejectionReason) {
        rejectionReason = rejectionReason || 'notfound';
        return function(model) {
            if (model[propertyName] !== value) {
                return $q.reject({reason: rejectionReason});
            }
            return model;
        }
    };


    // Debounces
    var debounces = {}

    function getDebounce(action, key) {
        return debounces[action] && debounces[action][key];
    }

    function setDebounce(action, key, debounce) {
        debounces[action] = debounces[action] || {};
        debounces[action][key] = debounce;
    }

    function createDebounce(action, key, fn) {
        var debounce = {deferred: $q.defer(), cancel: undefined};
        debounce.deferred.promise.then(function() {
            setDebounce(action, key, undefined);
        });
        setDebounce(action, key, debounce);
        return debounce;
    }

    function getOrCreateDebounce(action, key) {
        var debounce = getDebounce(action, key);
        if (!debounce) {
            debounce = createDebounce(action, key);
        }
        return debounce;
    }

    this.debouncedGet = function(modelName, id, delay) {
        var key = modelName + '.' + id,
            debounce = getOrCreateDebounce('get', key);
        $timeout.cancel(debounce.cancel);
        debounce.cancel = $timeout(function() {
            self.get(modelName, id)
                .then(debounce.deferred.resolve);
        }, delay);
        return debounce.deferred.promise;
    };

    this.debouncedIndex = function(modelName, delay) {
        var debounce = getOrCreateDebounce('get', modelName);
        $timeout.cancel(debounce.cancel);
        debounce.cancel = $timeout(function() {
            self.index(modelName)
                .then(debounce.deferred.resolve);
        }, delay);
        return debounce.deferred.promise;
    };

    this.debouncedRelation = function(modelName, id, relation, delay) {
        var key = [modelName, id, relation].join('.'),
            debounce = getOrCreateDebounce('get', key);
        $timeout.cancel(debounce.cancel);
        debounce.cancel = $timeout(function() {
            self.getRelation(modelName, id, relation)
                .then(debounce.deferred.resolve);
        }, delay);
        return debounce.deferred.promise;
    };



});

function addToArray(array, value) {
    if (!angular.isArray(array)) return;
    var index = array.indexOf(value);
    if (index === -1) {
        array.push(value)
    }
    return array;
}


function removeFromArray(array, value) {
    if (!angular.isArray) return;
    var index = array.indexOf(value);
    if (index >= 0) {
        array.splice(index, 1)
    }
    return array;
}

function removeByPredicate(array, predicate) {
    if (!angular.isArray(array)) return;
    var i = array.length;
    while(i--) {
        if (predicate(array[i])) {
            array.splice(i, 1);
        }
    }
}